<template>
  <div class="intro-page">
    <el-form ref="form" label-position="top">
      <p>&nbsp;</p>
      <h1>S.H.A.P.E.</h1>

      <p>
        S.H.A.P.E. is an acrostic made popular by Pastor Rick Warren, of Saddleback Church in Southern California.
        This assessment was adapted from Pastor Rick's material to help you better understand who God made you to be.
        As you begin unpacking your God-given "S.H.A.P.E.", it is our earnest prayer that you will understand more fully
        what it means for you to serve God and His Kingdom so that your passion can meet God's purpose.
      </p>

      <p>
        The primary reason for this formalized assessment is simply to help you discover which direction you may choose
        to explore. The best way for you to truly discover your best fit for ministry is to "get in the game" and try
        it out!
      </p>

      <p>
        Block out approximately 15 minutes to complete the assessment.
      </p>

      <p>&nbsp;</p>

      <ui-form-actions>
        <el-button type="primary" @click="goForward">Continue</el-button>
      </ui-form-actions>
    </el-form>
  </div>
</template>

<script>
  /* eslint-disable max-len */

  export default {
    name: 'Intro',
    methods: {
      goForward() {
        this.$router.push({ path: '/campus' });
      },
    },
  };
</script>

<style>
  .intro-page {
    font-size: 1.25rem;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Intro.vue